module.exports = __webpack_public_path__ + "img/icon3.968b33ce.svg";